module.exports = __webpack_public_path__ + "img/vu.6f87639a.svg";